import { createContext } from 'react'

export type ChangeSubCtx = {
	handleGoogleIAP(): Promise<void>
	handleSubChange(changeSub: () => Promise<void> | void, successRoute?: string): Promise<boolean>
	initSubChangeView(): Promise<void>
}

export const ChangeSubContext = /*@__PURE__*/ createContext<ChangeSubCtx>(null as any)
